import React, {Component} from 'react';
import {connect} from 'react-redux';
import Offers from './bus-offers';
import {
  Card,
  CardHeader,
  CardContent,
  Button,
  BottomNavigation,
  BottomNavigationAction,
  Avatar,
  Snackbar,
  Grid,
  withStyles,
} from '@material-ui/core';
import {LOCALSTORAGE_KEY} from '../utils/constants.js';
import Profile from './profile';
import Trips from './trips';
import Wallet from './wallet';
import {formatDate} from '../utils/common-methods';
import {
  getCookie,
  CookieName,
  setCookie,
  eraseCookie,
} from '../utils/cookieManager';
import {
  setSearchQuery,
  setHomeActiveMenu,
  resetStore,
} from '../actions/main.js';
import '../App.scss';

const styles = {
  selected: {
    color: '#43A64E !important',
    '&:focus': {
      outline: 'none !important',
    },
  },
  title: {
    textAlign: 'center',
    color: '#333',
  },
};

class SearchBox extends Component {
  constructor(props) {
    super(props);
    const activeMemu = this.props.searchQuery.activeMenu;
    if (activeMemu === null || activeMemu === '' || activeMemu === 'home') {
      this.props.reset();
      eraseCookie('SearchClicked');
    }
    this.state = {
      isSnackBarOpen: false,
    };
    if (!getCookie('rbooking-bus Visited')) {
      setCookie('rbooking-bus Visited', true);
    }
  }

  handleOnClick = (event, type) => {
    if (type === 'source-select') {
      this.props.history.push('/select-city/source');
    } else if (type === 'destination-select') {
      this.props.history.push('/select-city/destination');
    } else if (type === 'doj-select') {
      const query = {type: 'doj', data: event.target.value};
      this.props.setSearchQuery(query);
      window.localStorage.setItem(LOCALSTORAGE_KEY.DOJ, JSON.stringify(query));
    } else if (type === 'search-buses') {
      const query = this.props.searchQuery;

      if (!query.source.city && !query.destination.city) {
        return this.openSnackBar('Please Enter Source and Destination');
      } else if (!query.source.city) {
        return this.openSnackBar('Please Enter Source ');
      } else if (!query.destination.city) {
        return this.openSnackBar('Please Enter Destination ');
      } else if (query.source.city === query.destination.city) {
        return this.openSnackBar('Source and Destination Cannot be Same!');
      }

      if (query.source.city && query.destination.city) {
        this.props.history.push(
          `/rbooking-bus/from/${query.source.city}/to/${
            query.destination.city
          }/${formatDate(query.doj, 'server')}`
        );
      }
    }
  };

  swapStn = () => {
    let query;
    const s = JSON.parse(
      window.localStorage.getItem(LOCALSTORAGE_KEY.SOURCE_CITY)
    );
    const d = JSON.parse(
      window.localStorage.getItem(LOCALSTORAGE_KEY.DESTINATION_CITY)
    );

    if (d && s) {
      query = {type: 'source', data: d.data};
      this.props.setSearchQuery(query);
      window.localStorage.setItem(
        LOCALSTORAGE_KEY.SOURCE_CITY,
        JSON.stringify(query)
      );

      query = {type: 'destination', data: s.data};
      this.props.setSearchQuery(query);
      window.localStorage.setItem(
        LOCALSTORAGE_KEY.DESTINATION_CITY,
        JSON.stringify(query)
      );
    } else {
      this.openSnackBar(' Please Enter Source and Destination!');
    }
  };

  componentDidMount() {
    const dojQuery = window.localStorage.getItem(LOCALSTORAGE_KEY.DOJ);
    let today = new Date();
    if (dojQuery) {
      let doj = JSON.parse(dojQuery);
      if (new Date(doj.data) < today) {
        const query = {type: 'doj', data: formatDate(today)};
        this.props.setSearchQuery(query);
      } else {
        this.props.setSearchQuery(JSON.parse(dojQuery));
      }
    } else {
      const query = {type: 'doj', data: formatDate(today)};
      this.props.setSearchQuery(query);
    }

    const sQuery = window.localStorage.getItem(LOCALSTORAGE_KEY.SOURCE_CITY);
    if (sQuery) {
      this.props.setSearchQuery(JSON.parse(sQuery));
    }
    const dQuery = window.localStorage.getItem(
      LOCALSTORAGE_KEY.DESTINATION_CITY
    );
    if (dQuery) {
      this.props.setSearchQuery(JSON.parse(dQuery));
    }
    this.userProfileImg = getCookie(CookieName.USERIMG);
  }

  openSnackBar = (message) => {
    const msg = (
      <div className="snackbar-msg" id="message-id">
        {message}
      </div>
    );
    this.setState({isSnackBarOpen: true, message: msg});
  };

  handleChangeMenu = (event, value) => {
    this.props.setHomeActiveMenu(value);
  };

  handleClose = () => {
    this.setState({isSnackBarOpen: false});
  };

  handleDate = (type) => {
    let today = new Date();
    let query = {};
    if (type === 'today') {
      query = {type: 'doj', data: formatDate(today)};
      this.props.setSearchQuery(query);
    } else {
      query = {type: 'doj', data: formatDate(today, type)};
      this.props.setSearchQuery(query);
    }
    window.localStorage.setItem(LOCALSTORAGE_KEY.DOJ, JSON.stringify(query));
  };

  render() {
    let today = new Date();

    const q = this.props.searchQuery;
    const source =
      q && q.source.city ? (
        <span>{q.source.city}</span>
      ) : (
        <label>FROM (Ex: Bangalore)</label>
      );
    const destination =
      q && q.destination.city ? (
        <span>{q.destination.city}</span>
      ) : (
        <label>TO (Ex: Hyderabad)</label>
      );

    const otherServices = (
      <div className="other-services">
        <div>BUS SERVICES</div>
        <Card className="card-home">
          <CardContent className="card-content">
            <Grid container justifyContent="flex-start">
              <Grid
                item
                xs={3}
                className="right-border"
                onClick={() =>
                  this.props.history.push('/rbooking-bus/cancel-ticket')
                }
              >
                <i className="material-icons">cancel</i>
                <br />
                Cancel
                <br />
                Bus
              </Grid>
              <Grid item xs={3} className="right-border">
                <a href="https://www.confirmtkt.com/rbooking">
                  <i className="material-icons">train</i>
                  <br />
                  Book
                  <br />
                  Train Tickets
                </a>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </div>
    );

    const homeBlock = (
      <div>
        <div className="header">
          <Grid container justifyContent="flex-start">
            <Grid item xs={4}>
              <img
                style={{height: '60px'}}
                src="https://www.confirmtkt.com/images/logo-white.png"
                alt="Confirmtkt"
              />
            </Grid>
            <Grid item xs={8} />
          </Grid>
        </div>
        <Card className="card-home search">
          <CardHeader
            title="SEARCH BUS TICKETS"
            className="card-header"
            style={styles.title}
          />
          <CardContent className="card-content">
            <Grid container justifyContent="flex-start">
              <Grid item xs={11}>
                <div onClick={(e) => this.handleOnClick(e, 'source-select')}>
                  <div className="input-field">{source}</div>
                  <hr />
                </div>

                <div
                  onClick={(e) => this.handleOnClick(e, 'destination-select')}
                >
                  <div className="input-field">{destination}</div>
                  <hr />
                </div>
              </Grid>
              <Grid item xs={1}>
                <div className="swap-container" onClick={this.swapStn}>
                  <i className="material-icons">swap_vert</i>
                </div>
              </Grid>
            </Grid>

            <div>
              <label>DEPART ON</label>
              <br />
              <Grid container justifyContent="flex-start">
                <Grid item xs={6}>
                  <input
                    className="date-input input-field"
                    type="date"
                    id="journey-date"
                    onChange={(e) => this.handleOnClick(e, 'doj-select')}
                    value={this.props.searchQuery.doj}
                    min={formatDate()}
                    max={formatDate(null, 'plus120Days')}
                  ></input>
                </Grid>
                <Grid item xs={6} className="switch-date">
                  <span
                    className={formatDate() === q.doj ? 'active' : ''}
                    style={{margin: '0px 2px'}}
                    onClick={() => this.handleDate('today')}
                  >
                    Today
                  </span>{' '}
                  {' | '}
                  <span
                    className={
                      formatDate(today, 'tomorrow') === q.doj ? 'active' : ''
                    }
                    style={{margin: '0px 2px'}}
                    onClick={() => this.handleDate('tomorrow')}
                  >
                    Tomorrow
                  </span>
                </Grid>
              </Grid>
              <hr />
            </div>
            <div onClick={(e) => this.handleOnClick(e, 'search-buses')}>
              <Button variant="contained" className="ctkt-btn-success">
                BOOK TICKETS
              </Button>
            </div>
            <br />
            <div className="support">
              For booking related queries call
              <a style={{color: 'black'}} href="tel:08068243910">
                {' 08068243910 '}
              </a>
            </div>
          </CardContent>
        </Card>
        {otherServices}
        <Offers />
      </div>
    );

    const bottommenu = (
      <div className="botttom-menu-container">
        <BottomNavigation
          value={this.state.activeMenu}
          showLabels
          onChange={this.handleChangeMenu}
        >
          <BottomNavigationAction
            label="Home"
            value="home"
            icon={<i className="material-icons">home</i>}
          />
          <BottomNavigationAction
            label="Wallet"
            value="wallet"
            icon={<i className="material-icons">account_balance_wallet</i>}
            onClick={() =>
              getCookie(CookieName.USERTOKEN)
                ? ''
                : this.props.history.push({
                    pathname: '/account-login',
                  })
            }
          />
          <BottomNavigationAction
            label="Trips"
            value="trips"
            icon={<i className="material-icons">confirmation_number</i>}
            onClick={() =>
              getCookie(CookieName.USERTOKEN)
                ? ''
                : this.props.history.push({
                    pathname: '/account-login',
                  })
            }
          />
          <BottomNavigationAction
            classes={{selected: this.props.classes.selected}}
            label="Profile"
            value="profile"
            icon={
              this.userProfileImg ? (
                <Avatar alt="user" src={this.userProfileImg} />
              ) : (
                <i className="material-icons">person</i>
              )
            }
            onClick={() =>
              getCookie(CookieName.USERTOKEN)
                ? ''
                : this.props.history.push({
                    pathname: '/account-login',
                  })
            }
          />
        </BottomNavigation>
      </div>
    );

    let displayBlock = homeBlock;
    if (q.activeMenu === 'wallet') {
      displayBlock = <Wallet history={this.props.history} />;
    }

    if (q.activeMenu === 'trips') {
      displayBlock = <Trips history={this.props.history} />;
    }

    if (q.activeMenu === 'profile') {
      displayBlock = <Profile history={this.props.history} />;
    }

    return (
      <div>
        <div className="search-home">{displayBlock}</div>
        {bottommenu}
        <Snackbar
          anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
          open={this.state.isSnackBarOpen}
          onClose={this.handleClose}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          autoHideDuration={5000}
          message={this.state.message}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    searchQuery: state.searchReducer,
    busListingReducer: state.busListingReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setSearchQuery: (query) => {
      dispatch(setSearchQuery(query));
    },
    setHomeActiveMenu: (menu) => {
      dispatch(setHomeActiveMenu(menu));
    },
    reset: () => {
      dispatch(resetStore());
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(SearchBox));
